module.exports = __webpack_public_path__ + "media/images/mikulas_25-f6d75185456b36aff9211a335fcf6eef.jpg";